export const getApiServer = (): string => {
  return process.env.REACT_APP_API_ADDRESS || "https://api.dxlegends.com/api";
};

/**
 * Gets the post text based on the preferred language and available translations.
 */
export const getPostText = (post: any, preferredLang: string = 'en'): string => {
  if (!post) return 'No content';
  
  const translations = post.translations as Record<string, { text: string }>;
  if (translations && Object.keys(translations).length > 0) {
    return translations[preferredLang]?.text || 
           translations['en']?.text || 
           Object.values(translations)[0]?.text || 
           post.textEn || 
           post.textEs || 
           'No content';
  }
  
  return post.textEn || post.textEs || 'No content';
};

